import moment from 'moment-timezone'
import { createFieldClass, controls } from 'react-redux-form'
import emailValidator from 'email-validator'
import { parseDateTime } from 'utils/date'
import owasp from 'owasp-password-strength-test'
import { isMobilePhone, isMobilePhoneLocales } from 'validator'
import config from '../config'

export const TextField = createFieldClass({ FormControl: controls.text })

export const SelectField = createFieldClass({ FormControl: controls.select })

export const TextareaField = createFieldClass({ FormControl: controls.textarea })

export const validators = {

  isEmpty(value) {
    return !value
  },

  isRequired(value) {
    if (value && value.length > 0 && typeof value === 'string') {
      return !!value.trim()
    }
    return !!value
  },

  isBoolean(value) {
    return typeof value === 'boolean'
  },

  isNumber(value) {
    return typeof value === 'number' && isFinite(value)
  },

  isString(value) {
    return typeof value === 'string'
  },

  isEmail(value) {
    if (value && value.length > 0) {
      return emailValidator.validate(value)
    }
    return true
  },

  isNotAfterDate(date1, date2) {
    const parsedDate1 = parseDateTime(date1)
    const parsedDate2 = parseDateTime(date2)

    if (parsedDate1 === null || parsedDate2 === null) {
      return true
    }

    return parsedDate1.toDate() < parsedDate2.toDate()
  },

  isNotPastDate(value) {
    const parsedValue = parseDateTime(value)
    if (parsedValue == null) {
      return true
    }
    return parsedValue.toDate() > Date.now()
  },

  isNotTooOldForLive(value) {
    const parsedValue = parseDateTime(value)
    if (parsedValue == null) {
      return true
    }
    return parsedValue.toDate() > (Date.now() - (1000 * 60 * 60))
  },

  isValidSingleHireEnd(value, jobAd) {
    if (!jobAd.singleHireEndsAt) {
      return true
    }
    return value && moment(jobAd.singleHireEndsAt).isAfter(value)
  },

  isValidPassword(value) {
    owasp.config({ minLength: 12 })
    const result = owasp.test(value)
    return !result.requiredTestErrors.length > 0
  },

  isValidString(value) {
    return typeof value === 'string' && value.length >= 1 && /\S/.test(value)
  },

  passwordsMatch(value, value2) {
    return value === value2
  },

  isInternationalPhoneNumber(value) {
    const blockedCountryCodes = Object.keys(config.EXCLUDED_SMS_COUNTRY_CODES)
    return isMobilePhone(
      `${value}`,
      isMobilePhoneLocales.filter(
        locale => !blockedCountryCodes.includes(locale)
      ),
      { strictMode: true }
    )
  },
}

export function getValueAndFieldByModel(state, model) {
  const [modelName, fieldName] = model.split('.')
  const value = state[modelName][fieldName]
  const field = state[`${modelName}Form`][fieldName]
  return { value, field }
}
